export const TrackingIds = {
  editAverageProductionAmountModal: {
    saveButton: 'edit-average-production-amount-modal-save-button',
    closeButton: 'edit-average-production-amount-modal-close-button',
  },
};

export const generateTrackingId = ({ trackingId, base }: { trackingId?: string; base?: string }) => {
  return [base, trackingId].filter((str) => !!str).join('-');
};
